module.exports = __webpack_public_path__ + "img/P150T_weapon_157.898ca505.png";